export var LpFeeStartDate;
(function (LpFeeStartDate) {
    LpFeeStartDate["FundFirstCloseDate"] = "FUND_FIRST_CLOSE_DATE";
    LpFeeStartDate["LpSpecificClosedFirstTime"] = "LP_SPECIFIC_CLOSE_DATE";
    LpFeeStartDate["DateOfFirstFundInvestment"] = "DATE_OF_FIRST_FUND_INVESTMENT";
})(LpFeeStartDate || (LpFeeStartDate = {}));
export var LpArrearsCalculation;
(function (LpArrearsCalculation) {
    LpArrearsCalculation["BasedOnPeriodEndingAmount"] = "BASED_ON_PERIOD_ENDING_AMOUNT";
})(LpArrearsCalculation || (LpArrearsCalculation = {}));
export var LpFeeType;
(function (LpFeeType) {
    LpFeeType["RecurringPercentage"] = "RECURRING_PERCENTAGE";
    LpFeeType["OneOffFixed"] = "ONE_OFF_FIXED";
})(LpFeeType || (LpFeeType = {}));
export var LpFeeCalculationBasis;
(function (LpFeeCalculationBasis) {
    LpFeeCalculationBasis["CommittedCapital"] = "COMMITTED_CAPITAL";
    LpFeeCalculationBasis["NetCalledCapital"] = "NET_CALLED_CAPITAL";
    LpFeeCalculationBasis["TotalAcquisitionCost"] = "TOTAL_ACQUISITION_COST";
    LpFeeCalculationBasis["UnrealisedAssetCost"] = "UNREALISED_ASSET_COST";
    LpFeeCalculationBasis["Fixed"] = "FIXED";
})(LpFeeCalculationBasis || (LpFeeCalculationBasis = {}));
export var FeeApportionmentBasis;
(function (FeeApportionmentBasis) {
    FeeApportionmentBasis["OneNumberOfPeriods"] = "ONE_NUMBER_OF_PERIODS";
    FeeApportionmentBasis["ActualActual"] = "ACTUAL_ACTUAL";
})(FeeApportionmentBasis || (FeeApportionmentBasis = {}));
export var LpAccrualFrequency;
(function (LpAccrualFrequency) {
    LpAccrualFrequency["QuarterlyAdvance"] = "QUARTERLY_ADVANCE";
    LpAccrualFrequency["MonthlyAdvance"] = "MONTHLY_ADVANCE";
    LpAccrualFrequency["BiannualyAdvance"] = "BIANNUALY_ADVANCE";
    LpAccrualFrequency["AnnuallyAdvance"] = "ANNUALLY_ADVANCE";
    LpAccrualFrequency["QuarterlyArrears"] = "QUARTERLY_ARREARS";
    LpAccrualFrequency["MonthlyArrears"] = "MONTHLY_ARREARS";
    LpAccrualFrequency["BiannualyArrears"] = "BIANNUALY_ARREARS";
    LpAccrualFrequency["AnnuallyArrears"] = "ANNUALLY_ARREARS";
})(LpAccrualFrequency || (LpAccrualFrequency = {}));
export var LpFeeCommitmentStatus;
(function (LpFeeCommitmentStatus) {
    LpFeeCommitmentStatus["InsideCommitment"] = "INSIDE_COMMITMENT";
    LpFeeCommitmentStatus["OutsideCommitment"] = "OUTSIDE_COMMITMENT";
})(LpFeeCommitmentStatus || (LpFeeCommitmentStatus = {}));
//# sourceMappingURL=index.js.map